import BaseModel from "../models/BaseModel";
import type TemplateGroup from "../models/TemplateGroup";
import BaseModelMap from "../models/BaseModelMap";
import TreeViewModel from "../models/TreeviewModel";
import { isUiModeExpert, isUiModeProductAdmin } from "../uiMode";
import { DeviceClasses } from "../models/DeviceClasses";

const expertDeviceClasses = [
  DeviceClasses.Unknown,
  DeviceClasses.Actor,
  DeviceClasses.Button,
  DeviceClasses.SensorNew,
  DeviceClasses.DecentralActor,
];
const userDeviceClasses = [
  DeviceClasses.Actor,
  DeviceClasses.Button,
  DeviceClasses.SensorNew,
  DeviceClasses.DecentralActor,
];

export default class TemplateGroupsTreeViewModel extends TreeViewModel {
  constructor(obj: BaseModel) {
    super(obj);
  }

  get typedObj(): BaseModelMap<TemplateGroup> {
    return this.obj as BaseModelMap<TemplateGroup>;
  }

  get isSelectable(): boolean {
    return false;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return false;
  }

  getDisableEdit(): boolean {
    return true;
  }
  get childCollection(): Array<BaseModel> | undefined {
    return this.typedObj.sortBy("tagOrName").filter((tg) => {
      if (tg.tag === "C1") return true;
      if (isUiModeProductAdmin()) {
        return true;
      } else if (isUiModeExpert()) {
        return expertDeviceClasses.includes(tg.templateGroupType);
      } else {
        return userDeviceClasses.includes(tg.templateGroupType);
      }
    });
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // inline menu buttons
  //
  ////////////////////////////////////////////////////////////////////////////////////////

  getButtons(): JSX.Element[] {
    return [this.inlineButton_Open("ServerTemplateList.products")]; // no itx
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // context menu
  //
  ////////////////////////////////////////////////////////////////////////////////////////

  //  get contextMenuItems(): any {
  //   return {
  //     items: [super.baseContextMenuItems_Add("Neue Templategruppe hinzufügen")],
  //   };
  // }
}
